







import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import { MenuModuleMapper } from '@/store/modules/menu';
import { LanguageModuleMapper } from '@/store/modules/language';

import LangSwitcherFlag from './langSwitcherFlag.vue';

const Mappers = Vue.extend({
  computed: {
    ...LanguageModuleMapper.mapGetters(['checkLanguageInList']),
  },
  methods: {
    ...MenuModuleMapper.mapMutations({
      menuLoaded: 'setMenuState',
      setActive: 'setActive',
    }),
    ...ConstantsModuleMapper.mapMutations({
      setConstantsState: 'setConstantsState',
    }),
  },
});

@Component({
  components: {
    LangSwitcherFlag,
  },
})
export default class LangSwitcherItemComponent extends Mappers {
  @Prop()
  item!: object;

  async changeLocale(code: string) {
    this.$emit('close');
    localStorage.setItem('lang', code);

    const [
      lang,
      folder,
    ] = window.location.pathname.split('/').filter((item) => item.length);

    let path = window.location.origin;
    if (folder && folder.indexOf('help') !== -1 && process.env.NODE_ENV === 'production') {
      path = `/${code}/${folder}`;
    }
    path += this.$route.path;

    if (!!window.location.search && window.location.search.length > 0) {
      path += window.location.search;
    }
    window.location.replace(path);
  }
}
